import { render, staticRenderFns } from "./SingleResult.vue?vue&type=template&id=109394fc&scoped=true"
import script from "./SingleResult.vue?vue&type=script&lang=js"
export * from "./SingleResult.vue?vue&type=script&lang=js"
import style0 from "./SingleResult.scss?vue&type=style&index=0&id=109394fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109394fc",
  null
  
)

export default component.exports